<template>
  <div>

    <div class="dh-receipt" :class="{ 'dh-receipt--fluid': fluid }" :style="receiptStyle">
      <h3 class="dh-receipt-title" :style="h3style">
        <span class="dh-receipt-title__label">{{ title }}</span>
        <button
          v-if="canShowCancel"
          type="button"
          class="dh-order-cancel"
          aria-label="Cancel this order"
          title="Cancel this order"
          @click="cancelOrder()"
        >
          <i class="fa fa-trash" aria-hidden="true"></i>
        </button>
      </h3>
      <div class="dh-receipt-body" :style="receiptBodyStyle">

        <table class="table">
          <tbody>
          <tr v-for="(item,itemIndex) in order.items" :key="itemIndex">
            <td v-if="!disabled" class="show-hand" @click="deleteItem(item.itemNumber)"><i class="fa fa-trash"></i></td>
            <td>{{item.qty}}</td>
            <td>
              <div style="font-weight:800">{{item.title}}</div>
              <div v-if="item.description.length>0" style="vertical-align:bottom;white-space:pre-line;padding-left:1em;">{{item.description}}</div>
            </td>
            <td>{{currency(item.price).multiply( item.qty) }}</td>
          </tr>
          </tbody>
        </table>

      </div>
      <div class="dh-receipt-footer" :style="receiptFooterStyle">
        <div class="dh-summary-total"><span>SubTotal</span><span>{{currency(order.subTotal)}}</span></div>
        <div class="dh-summary-total"><span>Tax</span><span>{{currency(order.tax)}}</span></div>
        <div class="dh-summary-total-bold"><span>Total</span><span>{{currency(order.total)}}</span></div>
        <div v-if="order.totalItems" class="dh-counter" :style="textColorStyle"><span> Item{{(order.totalItems!=1)?'s':''}}</span><span>{{parseInt(order.totalItems)}}</span></div>
        <div v-if="orderLabel.length>0 || showNeverMindOnReceipt" class="dh-order-button">
          <button v-if="disabled && orderLabel.length>0" class="btn btn-fill" style="max-width:160px;white-space:normal;word-wrap:break-word;border-radius:.75em;" @click="enableOrder()">
            {{enableOrderLabel}}
          </button>
          <button v-if="!disabled && order.items.length>0" class="btn btn-fill" style="max-width:160px;white-space:normal;word-wrap:break-word;border-radius:.75em;background:#7fb847;font-weight:700;" @click="placeOrder()">{{orderLabel}}</button>
          <button
            v-if="showNeverMindOnReceipt"
            type="button"
            class="btn dh-order-back"
            @click="neverMind()"
          >
            {{ backButtonLabel }}
          </button>
        </div>
      </div>
    </div>

  </div>

</template>
<script>

  import { CalendarDay } from '@/components';
  import Currency        from "currency.js";
  import Moment          from "moment";
  
  export default {
    
    props     : {
      orderDate: {type: [ Date, String, Object ], default: null},
      title    : {type: String, default: ""},

      orderLabel      : {type: String, default: ""},
      enableOrderLabel: {type: String, default: "Edit Order"},
      disabled        : {type: Boolean, default: false},
      disabledColor   : {type: String, default: "#ccc"},
      color           : {type: String, default: "#e3a03b"},
      textColor       : {type: String, default: "white"},
      receiptTextColor: {type: String, default: "black"},
      fontSize        : {type: String, default: "medium"},
      borderFontSize  : {type: String, default: "2em"},

      order: {type: Object, default: () => {}},
      fluid: {type: Boolean, default: false},
      showMenuBackButton: { type: Boolean, default: false },
      backButtonLabel: { type: String, default: 'Back' },

    },
    components: {
      CalendarDay,
      Moment
    },
    watch     : {
      orderDate(newVal, oldval) {
        this.makeDateNames();
      }
    },
    computed  : {
      receiptStyle() {
        return "background: " + this.color +
               ";border: 2px solid " + this.color + ";";
      },
      receiptBodyStyle() {
        let style = "color:" + this.receiptTextColor + ";";
        if(this.disabled) {
          style += "background:" + this.disabledColor + ";";
        }
        return style;
      },
      h3style() {
        return "color: " + this.textColor + ";";
      },
      textColorStyle() {
        return "color:" + this.textColor + ";";
      },
      receiptFooterStyle() {
        return "color:" + this.textColor + ";"
      },
      showNeverMindOnReceipt() {
        if (!this.showMenuBackButton || !this.order || !this.order.items || !this.order.items.length) {
          return false;
        }
        return !!(this.order._id || this.order.id);
      },
      // Only while the receipt is editable — avoids canceling after ordering is closed
      canShowCancel() {
        if (this.disabled || !this.orderLabel || !this.orderLabel.length) {
          return false;
        }
        return !!(this.order && this.order.items && this.order.items.length);
      },

    },
    data() {
      return {
        monthName: "",
        dayName  : "",
        dayNumber: 0,
        selected : -1
      }
    },
    created() {
      this.makeDateNames();
    },
    methods   : {
      currency(c) {
        return Currency(c);
      },
      moment(d) {
        return Moment(d);
      },
      newTransaction() {
        this.item        = null;
        this.order.items = [];
      },
      placeOrder() {
        this.$emit("order", this.order);
      },
      cancelOrder() {
        if (this.disabled || !this.canShowCancel) {
          return;
        }
        this.$emit("cancel", this.order);
      },
      enableOrder() {
        this.$emit("enable", this.order);
      },
      neverMind() {
        this.$emit('never-mind');
      },
      deleteItem(itemNumber) {
        if (this.disabled) {
          return;
        }
        if(this.order.items.length === 0) {
          return;
        }
        this.$emit("delete", itemNumber);
      },
      defaultDayName() {
        return this.moment(this.orderDate).format('dddd');
      },
      makeDateNames() {
        this.dayNumber = this.moment(this.orderDate).format('D');
        this.monthName = this.moment(this.orderDate).format('MMMM');

        if(this.title !== "") {
          this.borderTitle = this.title;
        } else {
          this.borderTitle = this.defaultDayName();
        }
      }
    }
  }
</script>
<style scoped lang="scss">

  .dh-receipt-frame {
  }

  .dh-receipt {
    position: relative;
    float: left;
    margin: 1em;
    border-radius: 1em;
    padding: 3px;
    height: 600px;
    width: 400px;
    min-height: 600px;
    min-width: 300px;
  }

  .dh-receipt-title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: .5em;
    margin: 0;
    min-height: 2.25rem;
    padding: 0.2rem 2.5rem;
    box-sizing: border-box;
  }

  .dh-receipt-title__label {
    display: block;
    width: 100%;
    text-align: center;
  }

  .dh-receipt-body {
    position: absolute;
    border-radius: .75em;
    margin-top: 4px;
    height: 464px;
    width: 390px;
    min-height: 464px;
    min-width: 344px;
    padding: 2px;
    display: table-cell;
    overflow-y: auto;
    background: white;
  }


  .dh-counter {
    left: -18px;
    bottom: 0px;

    position: absolute;
    height: 80px;
    width: 80px;
    border-radius: 1em;

    span:first-child {
      position: absolute;
      bottom: 4px;
      left: 14px;
      font-size: 1em;
      vertical-align: bottom;
      text-align: center;
    }

    span:nth-child(2) {
      position: absolute;
      bottom: 14px;
      left: 25px;
      font-size: 3em;
      font-weight: 900;
    }

  }

  .dh-order-cancel {
    position: absolute;
    top: 50%;
    right: 0.25rem;
    transform: translateY(-50%);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 0.4rem;
    background: transparent;
    color: #fff;
    font-size: 1.15rem;
    font-weight: 400;
    line-height: 1;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    &:focus {
      outline: 2px solid rgba(255, 255, 255, 0.85);
      outline-offset: 1px;
    }
  }


  .dh-order-button {
    position: absolute;
    border-radius: .75em;
    text-align: center;

    top: 0;
    left: -185px;
    width: 170px;
    height: 80px;
  }


  .dh-summary-total {
    line-height:.85em;
    width: 180px;
    display: inline-block;

    span:first-child {
      display: table-cell;
      width: 110px;
      text-align: right;
    }

    span:nth-child(2) {
      width: 70px;
      display: table-cell;
      text-align: right;
      font-weight: 900;
    }
  }

  .dh-summary-total-bold {
    width: 180px;
    display: inline-block;

    span:first-child {
      display: table-cell;
      width: 110px;
      text-align: right;
    }

    span:nth-child(2) {
      width: 70px;
      font-size: 1.25em;
      display: table-cell;
      text-align: right;
      font-weight: 900;
    }
  }


  .dh-receipt-footer {
    position: absolute;
    bottom: 0;
    left: 192px;
    margin-bottom: 4px;
    border-radius: .75em;
    padding: 4px;
    height: 80px;
    width: 200px;

  }

  .dh-receipt--fluid {
    float: none;
    width: 100%;
    max-width: 100%;
    margin: 0;
    min-width: 0;
    height: auto;
    min-height: 20rem;
    display: flex;
    flex-direction: column;
    padding: 0.65rem;
    box-sizing: border-box;

    .dh-receipt-title {
      flex-shrink: 0;
      padding: 0.35rem 2.5rem;
    }

    .dh-order-cancel {
      right: 0.15rem;
    }

    .dh-receipt-body {
      position: relative;
      flex: 1 1 auto;
      width: 100%;
      min-width: 0;
      min-height: 10rem;
      max-height: 24rem;
      height: auto;
      margin-top: 0.35rem;
      padding: 0.35rem;
      box-sizing: border-box;
    }

    .dh-receipt-footer {
      position: static;
      flex-shrink: 0;
      width: 100%;
      height: auto;
      left: auto;
      margin: 0.75rem 0 0;
      padding: 0.65rem 0.5rem 0;
      border-top: 1px solid rgba(255, 255, 255, 0.25);
    }

    .dh-summary-total,
    .dh-summary-total-bold {
      width: 100%;
      max-width: 16rem;
      margin-left: auto;
      margin-right: 0;
      display: flex;
      justify-content: space-between;
      line-height: 1.4;
    }

    .dh-summary-total-bold span:nth-child(2) {
      font-size: 1.15em;
    }

    .dh-counter {
      position: static;
      width: auto;
      height: auto;
      margin: 0.35rem 0 0 auto;
      text-align: right;
      font-size: 0.9rem;

      span:first-child,
      span:nth-child(2) {
        position: static;
        display: inline;
        font-size: inherit;
        font-weight: 700;
      }

      span:nth-child(2) {
        margin-left: 0.35rem;
        font-size: 1.1rem;
      }
    }

    .dh-order-button {
      position: static;
      left: auto;
      top: auto;
      width: 100%;
      height: auto;
      margin-top: 0.65rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .btn {
        max-width: none !important;
        width: 100%;
      }

      .dh-order-back {
        border-radius: 0.75em;
        background: #fff;
        color: #7f1d1d;
        border: 1.5px solid #922b21;
        font-weight: 700;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
      }
    }
  }


</style>


